require("!!C:\\Vadim\\Projects\\Php\\zakupki\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Vadim\\Projects\\Php\\zakupki\\node_modules\\raw-loader\\index.js!C:\\Vadim\\Projects\\Php\\zakupki\\public\\js\\jquery.autosize.min.js"))


//////////////////
// WEBPACK FOOTER
// C:/Vadim/Projects/Php/zakupki/public/js/jquery.autosize.min.js
// module id = PXy+
// module chunks = 2 3 4 5 6 11 15